// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@3.12.0/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/registry.npmmirror.com+stylus-loader@3.0.2_stylus@0.54.8/node_modules/stylus-loader/index.js!./region.styl");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/.pnpm/registry.npmmirror.com+vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("b927b3d2", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/styles/region.styl
// module id = 89
// module chunks = 0